import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
export function StartWorking() {
  return <div className="w-full bg-zinc-950 py-24 relative overflow-hidden" data-id="element-620">
      <div className="absolute inset-0 opacity-5 animate-scanline" style={{
      backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, #00ff00 2px, #00ff00 4px)'
    }} data-id="element-621" />
      {/* Floating particles */}
      {[...Array(20)].map((_, i) => <div key={i} className="absolute rounded-full animate-float" style={{
      width: `${2 + Math.random() * 3}px`,
      height: `${2 + Math.random() * 3}px`,
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      backgroundColor: i % 2 === 0 ? '#22c55e' : '#f59e0b',
      animationDelay: `${Math.random() * 5}s`,
      animationDuration: `${10 + Math.random() * 15}s`,
      opacity: 0.3
    }} data-id="element-622" />)}
      <div className="container mx-auto px-6 relative z-10" data-id="element-623">
        <div className="max-w-4xl mx-auto" data-id="element-624">
          {/* Header */}
          <div className="text-center mb-12 animate-fade-in-up" data-id="element-625">
            <div className="inline-block border-4 border-amber-500 bg-black px-6 py-3 mb-6 shadow-[0_0_40px_rgba(255,165,0,0.4)] animate-glow-amber" data-id="element-626">
              <h2 className="text-4xl md:text-5xl font-bold text-amber-500 font-mono" data-id="element-627">
                START WORKING TOGETHER
              </h2>
            </div>
            <p className="text-green-400 text-xl font-mono animate-fade-in-up" style={{
            animationDelay: '0.2s'
          }} data-id="element-628">
              // SIMPLE PROCESS. NO BUREAUCRACY.
            </p>
          </div>
          {/* Main CTA */}
          <div className="border-4 border-amber-600 bg-black p-10 mb-12 shadow-[0_0_50px_rgba(255,165,0,0.3)] animate-fade-in-up hover:shadow-[0_0_70px_rgba(255,165,0,0.5)] hover:scale-[1.02] transition-all duration-500 group relative overflow-hidden" style={{
          animationDelay: '0.3s'
        }} data-id="element-629">
            <div className="absolute inset-0 bg-gradient-to-br from-amber-950/0 via-amber-950/20 to-amber-950/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-630" />
            {/* Corner accents */}
            <div className="absolute top-2 left-2 w-8 h-8 border-t-2 border-l-2 border-amber-400 animate-pulse" data-id="element-631" />
            <div className="absolute bottom-2 right-2 w-8 h-8 border-b-2 border-r-2 border-amber-400 animate-pulse" style={{
            animationDelay: '0.5s'
          }} data-id="element-632" />
            <div className="mb-8 relative z-10" data-id="element-633">
              <h3 className="text-2xl font-bold text-amber-500 mb-4 font-mono group-hover:text-glow transition-all duration-300" data-id="element-634">
                LET'S TALK
              </h3>
              <p className="text-amber-100 leading-relaxed mb-6" data-id="element-635">
                We'll challenge your assumptions, ask uncomfortable questions,
                and tell you honestly whether we can help. If we can't, we'll
                tell you that too.
              </p>
              <div className="space-y-3 mb-8" data-id="element-636">
                {['No sales pitch. Just honest conversation about your challenge.', "We'll tell you if automation is even the right solution.", "If we're not a fit, we'll say so and save everyone time."].map((text, i) => <div key={i} className="flex items-start gap-3 hover:translate-x-2 transition-transform duration-300" style={{
                animationDelay: `${0.4 + i * 0.1}s`
              }} data-id="element-637">
                    <CheckIcon className="w-5 h-5 text-green-400 mt-1 flex-shrink-0 animate-pulse" data-id="element-638" />
                    <span className="text-amber-100" data-id="element-639">{text}</span>
                  </div>)}
              </div>
            </div>
            <a href="https://www.linkedin.com/in/dawsonsewell" target="_blank" rel="noopener noreferrer" className="w-full bg-amber-600 hover:bg-amber-500 text-black font-bold py-5 px-8 transition-all duration-300 border-4 border-amber-400 shadow-[0_0_30px_rgba(255,165,0,0.5)] hover:shadow-[0_0_50px_rgba(255,165,0,0.8)] flex items-center justify-center gap-3 group/btn text-xl relative overflow-hidden animate-pulse-cta" data-id="element-640">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -translate-x-full group-hover/btn:translate-x-full transition-transform duration-1000" data-id="element-641" />
              <span className="tracking-wider relative z-10" data-id="element-642">
                CONNECT ON LINKEDIN
              </span>
              <ArrowRightIcon className="w-6 h-6 group-hover/btn:translate-x-2 transition-transform duration-300 relative z-10" data-id="element-643" />
            </a>
          </div>
          {/* Alternative contact */}
          <div className="grid md:grid-cols-2 gap-6" data-id="element-644">
            <div className="border-2 border-green-500 bg-black p-6 animate-fade-in-up hover:shadow-[0_0_30px_rgba(0,255,0,0.3)] hover:scale-[1.02] transition-all duration-500 group relative overflow-hidden" style={{
            animationDelay: '0.5s'
          }} data-id="element-645">
              <div className="absolute inset-0 bg-gradient-to-br from-green-950/0 via-green-950/20 to-green-950/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-646" />
              <div className="absolute top-1 left-1 w-4 h-4 border-t-2 border-l-2 border-green-400 animate-pulse" data-id="element-647" />
              <div className="absolute bottom-1 right-1 w-4 h-4 border-b-2 border-r-2 border-green-400 animate-pulse" style={{
              animationDelay: '0.5s'
            }} data-id="element-648" />
              <p className="text-green-400 font-mono text-sm mb-2 flex items-center gap-2 relative z-10" data-id="element-649">
                <span className="w-2 h-2 bg-green-400 animate-pulse" data-id="element-650" />
                {'>'} EMAIL
              </p>
              <p className="text-amber-100 mb-2 relative z-10" data-id="element-651">
                Prefer to start with email?
              </p>
              <a href="mailto:me@dawsonsewell.com" className="text-green-400 hover:text-amber-500 transition-colors font-mono relative z-10 group-hover:text-glow" data-id="element-652">
                me@dawsonsewell.com
              </a>
            </div>
            <div className="border-2 border-amber-500 bg-black p-6 animate-fade-in-up hover:shadow-[0_0_30px_rgba(255,165,0,0.3)] hover:scale-[1.02] transition-all duration-500 group relative overflow-hidden" style={{
            animationDelay: '0.6s'
          }} data-id="element-653">
              <div className="absolute inset-0 bg-gradient-to-br from-amber-950/0 via-amber-950/20 to-amber-950/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-654" />
              <div className="absolute top-1 left-1 w-4 h-4 border-t-2 border-l-2 border-amber-400 animate-pulse" data-id="element-655" />
              <div className="absolute bottom-1 right-1 w-4 h-4 border-b-2 border-r-2 border-amber-400 animate-pulse" style={{
              animationDelay: '0.5s'
            }} data-id="element-656" />
              <p className="text-amber-500 font-mono text-sm mb-2 flex items-center gap-2 relative z-10" data-id="element-657">
                <span className="w-2 h-2 bg-amber-500 animate-pulse" data-id="element-658" />
                {'>'} RESPONSE TIME
              </p>
              <p className="text-amber-100 mb-2 relative z-10" data-id="element-659">
                We respond within 24 hours.
              </p>
              <p className="text-green-400 font-mono text-sm relative z-10" data-id="element-660">
                GUARANTEED
              </p>
            </div>
          </div>
          {/* Final note */}
          <div className="mt-12 text-center animate-fade-in-up" style={{
          animationDelay: '0.7s'
        }} data-id="element-661">
            <p className="text-amber-100 text-sm leading-relaxed max-w-2xl mx-auto" data-id="element-662">
              We take on a limited number of projects at a time. If we're at
              capacity, we'll tell you when we have availability rather than
              rush and deliver mediocre work.
            </p>
          </div>
        </div>
      </div>
      <style data-id="element-663">{`
        @keyframes scanline {
          0% { transform: translateY(0); }
          100% { transform: translateY(100vh); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0) translateX(0) rotate(0deg); }
          50% { transform: translateY(-100px) translateX(50px) rotate(180deg); }
        }
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes glow-amber {
          0%, 100% { box-shadow: 0 0 40px rgba(255, 165, 0, 0.4); }
          50% { box-shadow: 0 0 60px rgba(255, 165, 0, 0.7); }
        }
        @keyframes pulse-cta {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.02); }
        }
        .animate-scanline {
          animation: scanline 8s linear infinite;
        }
        .animate-float {
          animation: float linear infinite;
        }
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
          opacity: 0;
        }
        .animate-glow-amber {
          animation: glow-amber 3s ease-in-out infinite;
        }
        .animate-pulse-cta {
          animation: pulse-cta 2s ease-in-out infinite;
        }
        .text-glow {
          text-shadow: 0 0 20px currentColor;
        }
      `}</style>
    </div>;
}